<template>
  <div v-if="!loading">
    <div class="info--text text-uppercase my-3">
      {{ generateMessage('requests.details.titles.general') }}
    </div>
    <div class="d-flex pl-3">
      <custom-simple-table
        style="width: 40%;"
        :item="property"
        i18-path="properties_360.fields"
        :table-keys="[
          'code',
          'name',
          'contractual_commitment.services_type',
          'usage.market_type',
        ]"
      />
      <custom-simple-table
        class="px-2"
        style="width: 40%"
        :item="property"
        i18-path="properties_360.fields"
        :table-keys="['address', 'entity', 'agency_name', 'entity_resp']"
      />
      <div style="width: 20%" class="px-2">
        <display-checkbox
          class="d-block"
          :label="
            generateMessage(
              'properties_360.fields.contractual_commitment.preventive_ordo'
            )
          "
          :input-value="property.contractual_commitment?.preventive_ordo"
        />
        <display-checkbox
          class="d-block"
          :label="
            generateMessage(
              'properties_360.fields.contractual_commitment.request_ordo'
            )
          "
          :input-value="property.contractual_commitment?.request_ordo"
        />
      </div>
    </div>
    <orders-accordion beginOpen />
  </div>
</template>
<script>
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { generateMessage } from '@/utils/i18n';
import { createNamespacedHelpers } from 'vuex';
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import OrdersAccordion from '@/pages/FRI/OrdersAccordion';

const { mapGetters } = createNamespacedHelpers('properties_360');

export default {
  name: 'property-general',
  components: { OrdersAccordion, CustomSimpleTable, DisplayCheckbox },
  computed: {
    ...mapGetters({ property: 'current', loading: 'isLoadingCurrent' }),
  },
  methods: {
    generateMessage,
  },
};
</script>
